import type { ManipulatorAxis } from './types';

export const AXIS_ORDER: ManipulatorAxis[] = ['x', 'y', 'z'];
export const PICK_RADIAL_TOLERANCE = 0.12;
export const PICK_EDGE_ON_THRESHOLD = 0.97;
